import React, { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { useDeleteBowtieAndFiltersMutation } from '../api/generated/bowtie-api';
import ConfirmActionToast from '../components/common/confirm-action-toast.component';
import { updateToast } from '../helpers/toast-util';

const useDeleteDiagram = (diagramId: string | null) => {
  const [loading, setLoading] = useState(false);
  const [deleteBowtieAndFilters] = useDeleteBowtieAndFiltersMutation();

  const handleDelete = useCallback(async () => {
    if (!diagramId) return;

    setLoading(true);

    const toastId = toast.loading('Deleting the diagram...');

    try {
      const result = await deleteBowtieAndFilters({ id: diagramId }).unwrap();

      if (result) {
        updateToast(toastId, 'Diagram deleted successfully', 'success');

        setTimeout(() => window.location.replace(`${window.location.origin}${window.location.pathname}`), 2000);
      } else if (!result) {
        updateToast(toastId, 'Unable to delete the diagram', 'error');
      }
    } catch {
      updateToast(toastId, 'Unable to delete the diagram', 'error');
    } finally {
      setLoading(false);
    }
  }, [diagramId]);

  const handleClick = useCallback(() => {
    toast(
      (props) =>
        React.createElement(ConfirmActionToast, {
          ...props,
          message: 'Are you sure you want to delete the diagram?',
          onConfirmActionClick: handleDelete,
          confirmActionLabel: 'Delete',
        }),
      {
        autoClose: 10_000, // auto close after 10 seconds
      }
    );
  }, [handleDelete]);

  return {
    loading,
    handleClick,
  };
};

export default useDeleteDiagram;
